import { render, staticRenderFns } from "./OResetPass.vue?vue&type=template&id=440642ba&scoped=true&"
import script from "./OResetPass.vue?vue&type=script&lang=ts&"
export * from "./OResetPass.vue?vue&type=script&lang=ts&"
import style0 from "./OResetPass.vue?vue&type=style&index=0&id=440642ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440642ba",
  null
  
)

export default component.exports